module.exports = __webpack_public_path__ + "static/media/marcello-marcelli.e8965fcd.jpg";